import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {Navigate} from 'react-router-dom';

import ResetPasswordConfirmForm from '../forms/ConfirmForm';

import {Box, SimpleGrid} from '@mantine/core';

import {useAccount} from 'hooks/useAccount';

import {confirmPasswordChange} from '../reducers/recordsSlice';

import {confirmResultSelector} from '../selectors';

export const ConfirmPage = () => {
    const account = useAccount();

    const dispatch = useDispatch();

    const confirmResult = useSelector((state) => confirmResultSelector(state));

    const handleSubmit = (values) => {
        dispatch(confirmPasswordChange({ account, values }));
        return false;
    };

    if (typeof account === 'undefined' || account === null) {
        return <Navigate to="/404" />;
    }

    if (confirmResult === 'success') {
        return <Navigate to={`/credentials/${account.id}`} />;
    }

    return (
        <SimpleGrid>
            <Box variant="h2">Enter Verification Code</Box>
            <Box>to continue to NEXT Cloud</Box>
            <Box mt="xl">
                {' '}
                We have sent a password reset code to your registered email
                address. Enter it below to reset your password.
            </Box>
            <Box mt="xl">
                <ResetPasswordConfirmForm handleSubmit={handleSubmit} />
            </Box>
        </SimpleGrid>
    );
};
